import { cn } from '@repo/lib/cn';

import { Chip } from '@/components/ui/chip';
import { Markdown } from '@/components/ui/markdown';
import { questionCorrect } from '@/lib/quiz';

import type { QuestionMatchingAnswerProps } from '.';

export function QuestionMatchingAnswer(questionMatchingAnswerProps: QuestionMatchingAnswerProps) {
  const { content, isSelected, correct, isDisabled, pairNumber, className, ...props } = questionMatchingAnswerProps;

  const { getStateClassNames } = questionCorrect(correct);

  return (
    <Chip content={pairNumber} variantColor="brand" size="md" placement="top-left" isInvisible={!pairNumber} className="h-full w-full">
      <div
        role="button"
        tabIndex={0}
        data-selected={isSelected}
        aria-disabled={isDisabled}
        className={cn(
          'data-[selected=true]:bg-surface-brand data-[selected=true]:border-border-brand data-[selected=true]:hover:bg-surface-brand-hove flex w-full cursor-pointer items-center justify-center rounded-md border p-3 transition-colors aria-disabled:cursor-not-allowed aria-disabled:opacity-70 md:p-4',
          getStateClassNames(),
          className
        )}
        {...props}
      >
        <Markdown
          content={content}
          imageClassName="max-h-68 rounded-sm justify-center"
          videoClassName="max-h-68 rounded-sm"
          audioClassName="flex-col sm:flex-row"
          textClassName="text-sm sm:text-base"
        />
      </div>
    </Chip>
  );
}
